import React from 'react';

import { resolveStatusByMatchingMatrixScore } from '../../util/user';
import { FormattedMessage } from '../../util/reactIntl';

import css from './ScoreBadge.css';
import classNames from 'classnames';
/**
 *
 * @param {{
 * scoreData: object,
 * scorePercentageText?: string,
 * rootClassName?: string,
 * }} param0
 * @returns
 */
const ScoreBadge = ({ scoreData, scorePercentageText, rootClassName }) => {
    if (!scoreData) {
        return null;
    }

    const { maxScore, total } = scoreData || {};
    const score = total === 0 || maxScore === 0 ? 0 : (total / maxScore) * 100;

    const scorePalette = resolveStatusByMatchingMatrixScore(score);

    return (
        <div className={classNames(css.root, rootClassName)} datatype="score-badge-root">
            <p className={css[scorePalette]}>
                {scorePercentageText || (
                    <FormattedMessage id={`ProfileSettingsForm.scoreBadge-${scorePalette}`} />
                )}
            </p>
        </div>
    );
};

export default ScoreBadge;
